import { action } from 'app/actions';

export const GET_EVALUATIONS_ONLINE = 'evaluation-system-student/GET_EVALUATIONS_ONLINE';
export const getEvaluationsOnline = (payload) => action(GET_EVALUATIONS_ONLINE, { payload });

export const ANSWER_EVALUATION_ONLINE = 'evaluation-system-student/ANSWER_EVALUATION_ONLINE';
export const answerEvaluationOnline = (payload) => action(ANSWER_EVALUATION_ONLINE, { payload });

export const ANSWER_QUESTION = 'evaluation-system-student/ANSWER_QUESTION';
export const answerQuestion = (payload) => action(ANSWER_QUESTION, { payload });

export const FINISH_SCHEDULED_ASSESSMENT = 'evaluation-system-student/FINISH_SCHEDULED_ASSESSMENT';
export const finishScheduledAssessment = (payload) =>
  action(FINISH_SCHEDULED_ASSESSMENT, { payload });

export const VIEW_EVALUATION_ONLINE = 'evaluation-system/VIEW_EVALUATION_ONLINE';
export const viewEvaluationOnline = (payload) => action(VIEW_EVALUATION_ONLINE, { payload });

export const GET_EVALUATION_ESSAY_DETAILS =
  'evaluation-system-student/GET_EVALUATION_ESSAY_DETAILS';
export const getEvaluationEssayDetails = (payload) =>
  action(GET_EVALUATION_ESSAY_DETAILS, { payload });

export const SAVE_EVALUATION_ESSAY_TEXT = 'evaluation-system-student/SAVE_EVALUATION_ESSAY_TEXT';
export const saveEvaluationEssayText = (payload) => action(SAVE_EVALUATION_ESSAY_TEXT, { payload });
